import { ThemeColors } from '@octopus-do/octopus-storybook'

import lightOrDark from '@/utils/color/lightOrDark'

export const getThemesByColor = (bgColor: string) => {
  return lightOrDark(bgColor)
}

export const getThemeClassName = (theme: 'light' | 'dark') => {
  return ThemeColors[theme]
}

export const defineStrictWhiteColor = (
  color: string,
  tolerance = 5
): boolean => {
  let r: number
  let g: number
  let b: number

  const isHexColor = (str: string) => /^#([0-9a-fA-F]{3}){1,2}$/.test(str)

  if (!isHexColor(color)) {
    throw new Error('Function requires color in hex format #AAAAAA or #AAA')
  }

  if (color.startsWith('#')) {
    const hexMatch = color.match(/^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6})$/)

    if (!hexMatch) {
      return false
    }

    let hex = hexMatch[1]

    if (hex.length === 3) {
      hex = hex
        .split('')
        .map((c) => c + c)
        .join('')
    }

    ;[r, g, b] = hex.match(/.{2}/g)!.map((hex) => parseInt(hex, 16))
  } else if (color.startsWith('rgb')) {
    const rgbMatch = color.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/)

    if (!rgbMatch) {
      return false
    }

    ;[r, g, b] = rgbMatch.slice(1).map(Number)
  } else {
    return false
  }

  return r >= 255 - tolerance && g >= 255 - tolerance && b >= 255 - tolerance
}
